<template>
  <div id="app">
    <NavigationBar />
    <Science />
    <DownloadLinks />
    <PageFooter />
  </div>
</template>

<script>
import Science from './views/attainment/science'
import NavigationBar from './views/attainment/components/NavigationBar.vue'
import PageFooter from './views/attainment/components/PageFooter.vue'
import DownloadLinks from './views/attainment/components/DownloadLinks.vue'

export default {
  name: 'App',
  components: {
    NavigationBar,
    PageFooter,
    Science,
    DownloadLinks
  }
}
</script>

<style>
* {
  margin:0;

  padding:0;
}
</style>
